// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Button_button__JBBzO {
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.Button_button__JBBzO:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.Button_button__JBBzO:active {
  transform: translateY(0);
}
.Button_button__JBBzO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.Button_button__JBBzO:disabled:hover {
  transform: none;
}

/* 🔹 Tamaños */
.Button_small__jToKs {
  padding: 0.4rem 0.8rem;
  font-size: var(--font-chica);
}

.Button_medium__Usyuv {
  padding: 0.6rem 1.2rem;
  font-size: var(--font-boton);
}

.Button_large__cizxk {
  padding: 0.8rem 2.6rem;
  font-size: var(--font-mediana);
}

@media (max-width: 768px) {
  .Button_small__jToKs {
    padding: 0.2rem 0.4rem;
    font-size: calc(var(--font-chica) * 0.9);
  }
  .Button_medium__Usyuv {
    font-size: var(--font-mobile);
    padding: 0.35rem 0.75rem;
    gap: 0.4rem;
  }
  .Button_large__cizxk {
    padding: 0.5rem 1.2rem;
    font-size: calc(var(--font-mediana) * 0.9);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEF;AAAE;EACE,YAAA;EACA,2BAAA;AAEJ;AACE;EACE,wBAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAEI;EACE,eAAA;AAAN;;AAKA,eAAA;AACA;EACE,sBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,sBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,sBAAA;EACA,8BAAA;AAFF;;AAKA;EACE;IACE,sBAAA;IACA,wCAAA;EAFF;EAKA;IACE,6BAAA;IACA,wBAAA;IACA,WAAA;EAHF;EAMA;IACE,sBAAA;IACA,0CAAA;EAJF;AACF","sourcesContent":[".button {\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-weight: 500;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n\r\n  &:hover {\r\n    opacity: 0.9;\r\n    transform: translateY(-1px);\r\n  }\r\n\r\n  &:active {\r\n    transform: translateY(0);\r\n  }\r\n\r\n  &:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none;\r\n\r\n    &:hover {\r\n      transform: none;\r\n    }\r\n  }\r\n}\r\n\r\n/* 🔹 Tamaños */\r\n.small {\r\n  padding: 0.4rem 0.8rem;\r\n  font-size: var(--font-chica);\r\n}\r\n\r\n.medium {\r\n  padding: 0.6rem 1.2rem;\r\n  font-size: var(--font-boton);\r\n}\r\n\r\n.large {\r\n  padding: 0.8rem 2.6rem;\r\n  font-size: var(--font-mediana);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .small {\r\n    padding: 0.2rem 0.4rem;\r\n    font-size: calc(var(--font-chica) * 0.9);\r\n  }\r\n\r\n  .medium {\r\n    font-size: var(--font-mobile);\r\n    padding: 0.35rem 0.75rem;\r\n    gap: 0.4rem;\r\n  }\r\n\r\n  .large {\r\n    padding: 0.5rem 1.2rem;\r\n    font-size: calc(var(--font-mediana) * 0.9);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__JBBzO`,
	"small": `Button_small__jToKs`,
	"medium": `Button_medium__Usyuv`,
	"large": `Button_large__cizxk`
};
export default ___CSS_LOADER_EXPORT___;
